import { FieldInput } from 'components/fieldInput';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import React, { Fragment, useContext, useEffect, useState } from 'react';
import styles from '../styles.module.scss';
import axios from 'axios';
import { AuthContext, ViewContext } from 'components/lib';
import CustomLoader from 'components/CustomLoader';

export function SelectPolicy({
  setModal,
  setStage,
  setSelected,
  setDrivers,
  setVehicles_and_trailers,
  accountInfo,
}) {
  const { user } = useContext(AuthContext);
  const context = useContext(ViewContext);
  const [policies, setPolicies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingPolicies, setLoadingPolicies] = useState(false);

  useEffect(() => {
    const fetchPolicies = async () => {
      setLoadingPolicies(true);
      try {
        const response = await axios.get('/api/command-center/policies', {
          params: { page: 1, pageSize: 100, statusFilter: 'active' },
        });
        setPolicies(
          response.data.data.data.policies.map((policy) => ({
            label: `${policy.named_insured} - ${policy.policy_number}`,
            value: policy.id,
            data: policy,
          }))
        );
      } catch (error) {
        console.error('Error fetching policies:', error);
        context.notification.show('Failed to load policies.', 'error', true, 'toast', 'x-circle');
      } finally {
        setLoadingPolicies(false);
      }
    };

    fetchPolicies();
  }, [context.notification]);

  const handleSubmit = async (values) => {
    const selectedPolicy = policies.find((policy) => policy.value === values.policy);
    if (!selectedPolicy) return;

    setLoading(true);
    const policy = selectedPolicy.data;
    const selectedPolicyDetails = {
      cc_policy_id: policy.id,
      policy_number: policy.policy_number,
      named_insured: policy.named_insured,
      insured_name: policy.named_insured,
      company_name: policy.named_insured,
      agency_id: policy.agency_id,
      source: policy.source,
      policy_status: policy.status,
      account_name: accountInfo?.name || '',
      agent_email: accountInfo?.owner_email || user?.email || '',
      quote_request: values.quote_request === 'true',
      carrier: null,
      effective_date: null,
      company_id: null,
    };

    setDrivers([]);
    setVehicles_and_trailers([]);
    setSelected({ drivers: [], vehicles_and_trailers: [], selected_policy: selectedPolicyDetails });
    setLoading(false);
    setStage('select_endorsement_type');
  };

  return (
    <div className={styles.insideWrapper}>
      <div className={styles.title}>Create an Endorsement</div>
      <div className={styles.line} />
      {loading ? (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
          <CustomLoader />
        </div>
      ) : (
        <Formik
          initialValues={{ policy: '', quote_request: 'false' }}
          validationSchema={Yup.object({
            policy: Yup.string().required('Policy is required'),
            quote_request: Yup.string().required('Please select Yes/No'),
          })}
          onSubmit={handleSubmit}
        >
          {({ errors, touched, handleSubmit, handleChange, handleBlur, submitForm, isValid, dirty }) => (
            <Fragment>
              <Form className={styles.form} onSubmit={handleSubmit}>
                <div className={styles.fieldRow} style={{ marginBottom: 10 }}>
                  <FieldInput id="quote_request" type="select" label="Is this a quote request?" handleChange={handleChange} handleBlur={handleBlur} showErrors errors={errors.quote_request} touched={touched.quote_request} required options={[{ value: 'true', label: 'Yes' }, { value: 'false', label: 'No' }]} />
                </div>
                <div className={styles.fieldRow} style={{ marginBottom: 10 }}>
                  <FieldInput id="policy" type="select" label="Insured Name - Policy Number" placeholder={loadingPolicies ? 'Loading Policies' : 'Select a policy'} handleChange={handleChange} handleBlur={handleBlur} showErrors errors={errors.policy} touched={touched.policy} required options={policies} disabled={loadingPolicies} />
                </div>
              </Form>
              <div className={styles.footer} style={{ justifyContent: 'flex-end' }}>
                <div className={styles.buttons}>
                  <button type="button" className={styles.cancel} onClick={() => setModal('')}>Cancel</button>
                  <button className={styles.save} onClick={submitForm} disabled={!isValid || !dirty}>Next</button>
                </div>
              </div>
            </Fragment>
          )}
        </Formik>
      )}
    </div>
  );
}
